import api from '@/service/api.js';
import { EventBus } from '@/event-bus.js';
export default {
    data(){
        return{
            callFlag:0,
			docheckin:0,
			str1:'{"cmd":"0","seatno":"1001","telno":"","para":""}',
			websocket:null,
			heartbeat_timer:0,
			hospitalCode:'',
			staffNo:'',
			staffPwd:'',
			wsRes:{},
			cdrid:'',
			info:'',
			user:{},
			phoneList:[],
			GXwsUrl:'',//线上演示
			GXcallFlag:false,
			UboxCallFlag:false
        }
    },
    async created(){
		this.hospitalCode=await api.getHospitalCode();
		this.user = JSON.parse(localStorage.getItem('user')).data;
		let callState=localStorage.getItem('callState');
		this.GXwsUrl=await api.getGXwsUrl();
		this.GXcallFlag=await api.getGXcallFlag();
		this.UboxCallFlag=await api.getUboxCallFlag();
		if (!window.flag) {
			// 确保事件只被调用一次
			window.flag = true;
			if(this.user.user.roleId !='6'&&this.user.user.roleId !='4'&&this.user.user.roleId !='1') return false;
			if(this.GXcallFlag){
				let phone = JSON.parse(this.getUser().phone);
				window.staffNo=phone.staffNo?phone.staffNo:'' // 员工工号
				window.staffPwd=phone.staffPwd?phone.staffPwd:'' // 员工密码
				if(!callState){
					this.callInit();
					console.log(this.hospitalCode,'连接wsinit------hospitalCode');
				}
			} else if(this.UboxCallFlag) {//if(this.hospitalCode=='YS_HM4')
				// let phone = JSON.parse(this.getUser());
				// window.staffNo=phone.staffNo?phone.staffNo:'';showMyself
				// window.staffPwd=phone.staffPwd?phone.staffPwd:'' // 员工密码

				// console.log(phone,'--------p',window.staffNo);
				if(!callState){
					// this.callInit();//冠讯呼叫
					window.uboxInit(this.callBack,this.callerHandle,this.statusHandle);//电话盒子呼叫
				}
			}
		}
    },
	mounted(){
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable);
	},
	destroyed() {
		if(this.GXcallFlag){
			this.DoDisConnect();
		}
		// 判断是否是在通话中
		let callState=localStorage.getItem('callState');
		if(callState){
			localStorage.removeItem('callState');
		}
		localStorage.removeItem('callerInfo');
		localStorage.removeItem('save');
		document.removeEventListener('visibilitychange', this.handleVisiable);
	},
    methods:{
		getUser() {
			return JSON.parse(localStorage.getItem('user')).data.user;
		},
		handleVisiable(e){
			if(this.user.user.roleId !='4'&&this.user.user.roleId !='6'&&this.user.user.roleId !='1') return false;
			let callState=localStorage.getItem('callState');
			if(this.GXcallFlag){
				if(!callState){
					// 关闭新开页面，回到列表页，刷新列表数据
					if(e.target.visibilityState == "visible"){
						this.callInit();
					} else {
						this.DisConnect();
					}
				}
			} else if(this.UboxCallFlag){//if(this.hospitalCode=='YS_HM4')
				if(!callState){
					if(e.target.visibilityState == "visible"){
						// this.callInit();///冠讯呼叫
					} else {
						console.log('隐藏rttt');
						// this.DisConnect();//冠讯呼叫

					}
				}
			}			
		},
        /*遂昌呼叫--*/
		callInit()  
		{
			this.callFlag=0;
			let user = JSON.parse(JSON.parse(localStorage.getItem("user")).data.user.phone);
			console.log(user,'======111',window);

			if(!window.staffNo){
				let phone = JSON.parse(JSON.parse(localStorage.getItem("user")).data.user.phone);
				window.staffNo=phone.staffNo?phone.staffNo:'' // 员工工号
				window.staffPwd=phone.staffPwd?phone.staffPwd:'' // 员工密码
			}
			// if(this.heartbeat_timer!=0) window.clearInterval(this.heartbeat_timer);//yhy2017-12-18
			// this.heartbeat_timer =setInterval(() => {
			// 	this.keepalive(window.websocket);
			// }, 5000); 
			this.InitSocket();
		},
		InitSocket() {
			this.docheckin=0;
			if(!window.websocket){
				// const wsUrl={
				// 	// ZJ_SC1
				// 	"ZJ_SC1":'ws://120.1.1.110:55555/',
				// 	'SD_ZQ1':'ws://192.168.1.92:55555',
				// 	// 'SD_ZQ1':'ws://120.220.247.124:55555/',
				// 	"YS_HM4":'ws://120.220.247.124:55555/',
				// }
				console.log(this.GXwsUrl,'----s',this.hospitalCode);
				window.websocket = new WebSocket(this.GXwsUrl);
				window.websocket.onopen = this.onOpen.bind(this);
				window.websocket.onclose = this.onClose.bind(this);
				window.websocket.onmessage = this.onMessage.bind(this)
				window.websocket.onerror = this.onError.bind(this);
			}
		},
		onOpen: function(evt)
		{
			this.writeToScreen("连接成功",this.docheckin);  
			if(this.docheckin==0){
				this.checkIn(window.staffNo,window.staffPwd,window.staffNo);
				// this.checkIn(8058,'gxlc@8058','8058');
				// switch (this.hospitalCode){
				// 	case 'SD_ZQ1':
				// 	case 'ZJ_SC1':
				// 	// case 'YS_HM4':
						
				// 		break;
				// 	// // 冠讯呼叫
				// 	// case 'YS_HM4':
				// 	// 	this.checkIn(window.staffNo,window.staffPwd,window.staffNo);
				// 	// 	break;
				// }
			}     
		},
		onClose:function(evt) 
		{
			this.callFlag=3;
			this.writeToScreen("连接关闭",evt); 

		},   
		onError:function(evt) 
		{ 
			this.callFlag=3;
			this.writeToScreen('连接错误' + evt.data); 
		},
		onMessage:function(evt)
		{
			this.callFlag=0;	      
			if(evt.data.length>4)
			{
				var json = JSON.parse(evt.data); 
				let para=json.para;
				let callState=localStorage.getItem('callState');
				console.log(json,'----------message',callState);
				if(json.cmd=='3'&&(json.state=='-19204'||json.state=='-19200')){
					this.dropCall(window.staffNo);
				}
				if(para.includes('cdrid')){
					var pattern = /cdrid=(\d+)/i;
					this.cdrid = para.match(pattern)[1];
					if(json.cmd=='0'&&json.state=='-1'){
						//telno
						this.statusHandle('calling')
						this.callerHandle(json.telno,this.cdrid)
					}else {//呼出
						this.addCallRecordEvt()
					}
				} else if(para=='UserHangup'){//挂机
					if(callState=='callout'){
						this.addCallRecordEvt()
					}
					let save=JSON.parse(localStorage.getItem('save'));
					if(callState=='callout'||this.phoneList.length==0||(callState=='callIn'&&save=='saved')){
						localStorage.removeItem('callerInfo');
						localStorage.removeItem('callState');
						localStorage.removeItem('route');
						setTimeout(() => {
							localStorage.removeItem('save');
						}, 1000);
					}
					this.statusHandle('finished')
				} else if(para=='out'){
					localStorage.removeItem('callState');
					localStorage.removeItem('callstatus');
					EventBus.$emit('update-callstatus','normal')
					localStorage.removeItem('route');
					this.statusHandle('normal')
					localStorage.removeItem('callerInfo');
					localStorage.removeItem('phoneRecordId');
				}
				// console.log(this.cdrid,'------88888888888888----',pattern);
				this.wsRes=json;      
				if(json.state==0 && json.para=="BeCheckout"){
					this.docheckin=0;
				}
			}      
		},
		async addCallRecordEvt(fileName){
			console.log(window.info,'----addrecord--挂机-----ii');
			// let patientId=this.$route.query.patientId
			let params = {
				patientId: window.info.patientId,
				phone: window.info.phone,
				relationship: window.info.relationship,
				callMode: (this.hospitalCode === 'AH_FY1') ? 'FY' : (fileName ? 'UBOX' : 'GX'),
				...(this.hospitalCode !== 'AH_FY1' ? { recording: this.cdrid || fileName } : {})
			};
			let res = await api.addCallRecord(params);
			if(res.code==1000){
				localStorage.setItem('phoneRecordId',res.data.phoneRecordId);
			}
		},
		DisConnect() {  
            if (window.websocket != null) { 
				this.writeToScreen( "DisConnect" );
                window.websocket.close();
                window.websocket = null;                 
            }  
        },
		DoDisConnect() {  
			if(this.docheckin==1) this.checkOut(this.seatno);
            this.DisConnect();         	             
        },
		keepalive(ws)
		{	 	
			this.callFlag++; 
			if(window.websocket.readyState == WebSocket.CONNECTING)
			{
				this.writeToScreen("连接正在建立");	
				return;
			}
			if(window.websocket.readyState == WebSocket.CLOSING)
			{
				this.writeToScreen("连接正在进行关闭");	
				return;
			}
			if(window.websocket.readyState == WebSocket.CLOSED)
			{
				this.writeToScreen("连接已关闭");	
				// this.InitSocket();   
				return;
			}
	
			if(this.docheckin && this.callFlag>6)
			{     
				this.callFlag=3;
				// this.InitSocket();   
				return ;
			}
			ws.send( '{}' );
		},
		writeToScreen(message) 
		{
			console.log(message,this.docheckin)
		},
		checkIn(seatno,password,telno)
		{
			this.docheckin=1;
			this.str1='{"cmd":"1","seatno":"'+seatno+'","telno":"'+telno+'","para":"'+password+'"}';
			window.websocket.send(this.str1);
			console.log('签入成功');

		},
		checkOut(seatno)
		{
			this.str1='{"cmd":"2","seatno":"'+seatno+'","telno":"","para":""}';
			this.docheckin=0;
			window.websocket.send(this.str1);
			console.log('签出');  	
		},
		// 拨号
		makeCall(telno,info)
		{
			if(!this.UboxCallFlag&&!this.GXcallFlag) return false;
			window.info={
				phone:telno,
				...info
			}
			if(this.GXcallFlag&&!window.websocket){//||this.hospitalCode=='YS_HM4'
				this.InitSocket();
			}
			console.log(window.info,'--------makecallinfo-----------------',window.staffNo,window.staffPwd);
			setTimeout(() => {
				if(this.GXcallFlag){
					this.str1='{"cmd":"3","seatno":"'+window.staffNo+'","telno":"'+telno+'","para":"1234"}';
					window.websocket.send(this.str1);
					if(this.wsRes.state<0){
						this.$message.error('电话呼出失败');
					} else {
						this.$message.success('电话呼出成功');
						localStorage.setItem('callState','callout');
						localStorage.setItem('route',JSON.stringify(this.$route.fullPath));
						this.statusHandle('calling');
					}
				}else if(this.UboxCallFlag){
					window.ubox_dialnum(telno,info,this.addCallRecordEvt,this.callBack,this.statusHandle);//电话盒子呼叫
				}
			}, 300);
			// this.str1='{"cmd":"3","seatno":"'+window.staffNo+'","telno":"'+telno+'","para":"10086c=06357290798"}';
			
		},
		dropCall(seatno)
		{
			this.str1='{"cmd":"4","seatno":"'+seatno+'","telno":"","para":""}';
			window.websocket.send(this.str1);
		},
		// message
		callBack(status,text){
			switch(status){
				case 'success':
					this.$message.success(text);
					break;
				case 'error':
					this.$message.error(text);
					break;
				default :
					this.$message.warning(text);
					break;

			}
		},
		// 呼入
		async callerHandle(phone,recording){
			/*
			recording:{
				ubox:fileName,
				冠讯：cdrid
			}
			*/ 

			if(!phone) return false;
			let callState=localStorage.getItem('callState');
			if(!callState){
				localStorage.setItem('callState','callIn');
				localStorage.setItem('callerInfo',JSON.stringify(phone+','+recording));
				this.statusHandle('calling')
			}
			// 请求phonelist接口
			let res=await api.getCallPhoneList({
				phone:phone,
				recording:recording
			});
			if(res.code==1000){
				EventBus.$emit('update-phoneList-value', res.data);
				this.phoneList=res.data.phoneList;
				// 存呼入记录id
				let phoneRecordId=localStorage.getItem('phoneRecordId');
				// if(!phoneRecordId){
					localStorage.setItem('phoneRecordId',res.data.phoneRecordId);
				// }
			} else {
				this.$message.error(res.message)
			}
			// this.dlg.callerAct=true;//弹屏/
		},
		//呼叫状态
		statusHandle(status){
			EventBus.$emit('update-callstatus', status);
			localStorage.setItem('callstatus',JSON.stringify(status));
			if(status!=='normal'){
				localStorage.setItem('route',JSON.stringify(this.$route.fullPath));
			} else if(status=='finished'&&this.phoneList.length==0){
				localStorage.removeItem('callerInfo');
				localStorage.removeItem('callState');
			}
				
		}
    }
}